import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import b from 'b_';
import PolicySection from '../PolicySection';
import PolicySectionHeader from '../PolicySectionHeader/PolicySectionHeader';
import FileTypesStore from '../../../stores/Policy/FileRules/FileTypesStore';
import FuseReadOnlySelect from '../../FuseControls/FuseReadOnlySelect';
import FuseConsoleCardFooter from '../../ConsoleFragments/FuseConsoleCardFooter';
import CheckboxContainer from '../../CheckboxContainer/CheckboxContainer';
import FuseReadOnlyCheckbox from '../../FuseControls/FuseReadOnlyCheckbox';
import { FTBody } from '../../Fuse';
import './FileTypes.css';

const block = b.lock('FileTypes');

class FileTypes extends Component {
    static propTypes = {
        store: FileTypesStore.PropType.isRequired,
        readOnly: PropTypes.bool,
    };

    render() {
        const { readOnly, store } = this.props;
        const { fileTypesSelect, matchAllFileTypes } = store;

        return <PolicySection grayBackground={!readOnly} readOnly={readOnly}>
            <PolicySectionHeader
                title="File Types"
                tooltipText={'Define the file types to which this rule pertains.'}
                isFixedTooltip
            />

            {(readOnly && matchAllFileTypes.isTrue) ?
                <FTBody>All Files</FTBody> :
                <Fragment>
                    {!readOnly ? <CheckboxContainer
                        readOnly={readOnly}
                        matchAll={matchAllFileTypes.isTrue}
                    >
                        <FuseReadOnlyCheckbox
                            store={matchAllFileTypes}
                            label="Match All Files"
                            qa="match-all-file-types"
                        />
                    </CheckboxContainer> : null}

                    {!matchAllFileTypes.isTrue ? <FuseReadOnlySelect
                        readOnly={readOnly}
                        store={fileTypesSelect}
                        fullWidth
                        searchable
                        containerClassName={block('SelectorContainer')}
                        placeholder="Select File Types"
                        searchLabel="Search by File Type, Extension or Description"
                        noOptionsLabel="No entries found"
                        wordBreakAll
                    /> : null}
                </Fragment>}

            {!readOnly ? <FuseConsoleCardFooter
                className={block('SectionFooter')}
                text={'At least one File Type is required to be selected.'}
            /> : null}
        </PolicySection>;
    }
}

export default observer(FileTypes);
